import React, { useEffect, useRef, useMemo } from 'react';
import axios from 'axios';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

function Contact() {
  const mapRef = useRef(null);
  const mapElRef = useRef(null);

  useEffect(() => {

    if (mapRef.current) return;

    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: markerIcon2x,
      iconUrl: markerIcon,
      shadowUrl: markerShadow,
    });

    const CENTER = L.latLng(52.33916, 1.13307);

    const BOUNDS = L.latLngBounds(
      [CENTER.lat - 0.01, CENTER.lng - 0.01],
      [CENTER.lat + 0.01, CENTER.lng + 0.01]
    );

    const map = L.map(mapElRef.current, {
      center: CENTER,
      zoom: 16,
      minZoom: 14,
      maxZoom: 18,
      maxBounds: BOUNDS,
      maxBoundsViscosity: 1.0,
      inertia: false,
      zoomControl: true,
      scrollWheelZoom: true,
      touchZoom: true,
      dragging: true,
    });
    mapRef.current = map;

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);

    L.marker(CENTER)
      .addTo(map)
      .bindPopup(
        `<div style="text-align:center;">
           <strong>Grainseed</strong><br/>
           Unit 3 Airfield Ind Park<br/>
           Langton Green Eye<br/>
           Suffolk<br/>
           IP23 7HN
         </div>`,
        { closeButton: false }
      )
      .openPopup();

    const ro = new ResizeObserver(() => {
      requestAnimationFrame(() => {
        const m = mapRef.current;
        if (m && m._mapPane) {
          try {
            m.invalidateSize({ animate: false });
          } catch {}
        }
      });
    });
    if (mapElRef.current) ro.observe(mapElRef.current);

    return () => {
      ro.disconnect();
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  return (
    <div className="contact-container">
      <header className="contact-header">
        <h1>Contact Us</h1>
        <p className="contact-subtitle">
          We would love to hear from you. Call, email, or send us a message.
        </p>
      </header>

      <section className="contact-grid">
        <div className="panel map-panel">
          <div className="panel-header">
            <h2>Our Office</h2>
            <p className="muted">Unit 3 Airfield Ind Park, Langton Green Eye, Suffolk, IP23 7HN</p>
          </div>

          <div className="inline-contact">
            <div>
              <strong>Telephone:</strong>{' '}
              <a href="tel:+441379873377" aria-label="Call Grainseed on 01379 873 377">
                01379 873 377
              </a>
            </div>
            <div>
              <strong>Email:</strong>{' '}
              <a href="mailto:info@grainseed.co.uk">info@grainseed.co.uk</a>
            </div>
          </div>

          <div ref={mapElRef} id="map" className="contact-map" />
        </div>
      </section>
    </div>
  );
}

export default Contact;
